import React from "react"
import ReactModal from "react-modal"
import * as styles from "./modal.module.scss"

if (typeof document === "object") {
  ReactModal.setAppElement(document.getElementById("___gatsby"))
}
const Modal = React.memo((props) => {
  return <ReactModal {...props} />
})

Modal.displayName = "Modal"
export default Modal
